import { Col, Form, Row, Button } from 'antd';
import Modal from 'antd/lib/modal/Modal';
import Title from 'antd/es/skeleton/Title';
import {
  CheckCircleOutlined,
  InfoCircleFilled,
  InfoCircleOutlined,
} from '@ant-design/icons';
import { CheckIcon } from 'assets/svg';

interface IProps {
  isVisible: boolean;
  onCancel?: () => void;
  onStay?: () => void;
  onOk: () => void;
}

const PopupOrderConfirm = (props: IProps): JSX.Element => {
  const { isVisible, onCancel, onStay, onOk } = props;
  return (
    <Modal
      open={isVisible}
      footer={null}
      closeIcon={true}
      width={'450px'}
      onCancel={onCancel}
    >
      <Col>
        <CheckCircleOutlined
          style={{
            display: 'block',
            marginTop: '10px',
            textAlign: 'center',
            fontSize: '34px',
            color: 'green',
          }}
        />
        <p
          style={{
            textAlign: 'center',
            fontWeight: 'bold',
            marginBottom: '30px',
            marginTop: '20px',
            fontSize: '16px',
          }}
        >
          {'Bạn có muốn gửi duyệt các sản phẩm '}
          <br />
          {'đã đăng ký không?'}
        </p>
      </Col>
      <Row gutter={16} justify="center">
        <Col span={10}>
          <Button
            style={{
              width: '100%',
              height: '40px',
              background: 'white',
              borderColor: '#00538F',
              color: '#00538F',
              borderRadius: '8px',
              fontWeight: 'bold',
            }}
            onClick={onStay}
          >
            Lưu và đăng ký tiếp
          </Button>
        </Col>
        <Col span={10}>
          <Button
            style={{
              width: '100%',
              height: '40px',
              background: '#00538F',
              borderColor: '#00538F',
              color: 'white',
              borderRadius: '8px',
            }}
            onClick={onOk}
          >
            Gửi duyệt
          </Button>
        </Col>
      </Row>
    </Modal>
  );
};

export default PopupOrderConfirm;
